import { c as _c } from "react/compiler-runtime";
import { useMediaQuery as useMediaQueryUtil } from '@systemeio/util';
import { useMetadataFromServer } from 'shared/hooks/use-metadata-from-server';
import { getBreakpointsByServerDeviceType } from './utils/get-breakpoints-by-server-device-type';
const useMediaQuery = () => {
  const $ = _c(2);
  const {
    data: metaDataFromServer
  } = useMetadataFromServer();
  const t0 = metaDataFromServer?.serverDeviceType;
  let t1;
  if ($[0] !== t0) {
    t1 = getBreakpointsByServerDeviceType(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initialBreakpoints = t1;
  return useMediaQueryUtil(initialBreakpoints);
};
export default useMediaQuery;